import React,{useState,useEffect} from 'react';
import { useNavigate,useLocation } from 'react-router-dom';
import {TextAreaInput1, TextInput} from '../../components/input';
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button';
import { toast } from 'react-hot-toast';
import SettingsMenu from '../staticscreens/SettingsMenu';
import GoBack from '../../components/back/GoBack';
import { CreateClassHomePageDataService, UpdateClassHomePageDataService } from '../../services/class_booking/classHomePageDataServices';
import { UploadUserFile } from '../../services/AuthServices';
import Uploader from '../../components/Uploader';
import { Select } from 'antd';
import {BiErrorCircle} from 'react-icons/bi'
import { GetFileStandardService } from '../../services/admin/FileStandardServices';

function ClassHomePageDataCE() {

  const navigate = useNavigate()  
  const location = useLocation()
  const {state} = useLocation()

  const [data,setdata] = useState({
    title:'',
    description:'',
    video:'',
    image:'',
    class:''
  })

  const [filter_standard,setfilter_standard] = useState([])

  useEffect(()=>{
    if(location?.pathname?.split('/')[location?.pathname?.split('/').length - 1] === 'edit'){
     setdata({...state,class:{
          label: state?.class?.label,
          value: state?.class?._id,
        }})
    }
    getfilter_standard()

  },[])

  async function getfilter_standard() {
      const response = await GetFileStandardService();
      let arr = [];
      response?.data?.datas?.forEach((d) => {
        arr.push({
          label: d?.label,
          value: d?._id,
        });
      });
      setfilter_standard(arr);
    }

  const [error,seterror] = useState({
    title:'',
    description:'',
    video:'',
    image:'',
    class:''
  })

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }


  async function submitdata(){
    if(!data.title){
        seterror({...error,title:'This Field is required*'})
    }else if(!data.description){
        seterror({...error,description:'This Field is required*'})
    }else if(!data.image){
        seterror({...error,image:'This Field is required*'})
    }else if(!data.video){
        seterror({...error,video:'This Field is required*'})
    }else if(!data.class){
        seterror({...error,class:'This Field is required*'})
    }else{
       
        let send_data = {...data}
        send_data['class'] = data?.class?.value

      
        if(location.pathname.split('/')[location.pathname.split('/').length - 1] === 'create'){
            const response = await CreateClassHomePageDataService(send_data)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 201){
                toast.success("Class Home Page Data Created Successfully")
                resetform()
            }
        }else{
            const response = await UpdateClassHomePageDataService(send_data,state?._id)
            if(response.status === 422){
                seterror({...error,...response?.data?.errors})
            }
            if(response.status === 200){
                toast.success("Class Home Page Data Updated Successfully")
                resetform()
                navigate(-1)
            }
        }
        
    }
  }

  function resetform(){
    setdata({
        title:'',
        description:'',
        video:'',
        image:'',
        class:''
      })
    seterror({
        title:'',
        description:'',
        video:'',
        image:'',
        class:''
      })
  }

  async function handleSelect(e,e1){
    if(e1 === 'class'){
      setdata({...data,class:filter_standard?.find((t)=>t?.value === e)})
      seterror({...error,class:''})
    }
  }


  async function UploadFile(e,name){
    console.log("e",e)
    console.log("e,name",e,name)
    const fd = new FormData()
    fd.append('file',e)
    const response = await UploadUserFile(fd)
    setdata({...data,[name]:response?.data?.data})

  }


  return (
    <div className='md:h-screen pt-5 md:pt-0 md:max-h-screen md:min-h-screen md:overflow-hidden'>
        <div className='md:flex'> 
         <SettingsMenu />
          <div className='px-5 md:w-full'>

          
        <div className='md:flex md:w-full md:min-h-screen md:max-h-screen md:overflow-y-scroll mb-10'>
        <div className='w-full md:border-r md:w-64 md:pr-5 md:pt-5'>
        <GoBack />  

        <h6 className='font-[700] mb-1'>Create/Edit Class Home Page Data</h6>
          <h6 className='text-[11px] p-2  mb-2 bg-slate-100'>Use the below form to create or update a class home page data</h6>
        



        <TextInput 
         label={'Title'}  
         variant="standard"
         name="title"
         type="text"
         error={error.title}
         value={data.title}
         handlechange={handlechange}
         placeholder="Enter your Amount"
         />


        <TextAreaInput1 
         label={'Description'}  
         variant="standard"
         name="description"
         type="text"
         error={error.description}
         value={data.description}
         handlechange={handlechange}
         placeholder=""
         />

         <Uploader error={error?.image} name="image" required={false} label={'Image'} image={data?.image}  setimagefunc={(e)=>{UploadFile(e,'image');seterror({...error,image:''})}}  removeimageuploadfunc = {()=>{setdata({...data,image:''});seterror({...error,image:''})}} />
         <Uploader error={error?.video} name="video" required={false} label={'Video'} image={data?.video}  setimagefunc={(e)=>{UploadFile(e,'video');seterror({...error,video:''})}}  removeimageuploadfunc = {()=>{setdata({...data,video:''});seterror({...error,video:''})}} />


 <div className="w-full mt-2">
          <div className='flex justify-between items-center'>
          <h6 className='text-[12px] mb-1'>Class</h6>
          </div>

                   <Select
                     value={data.class} 
                     error={error.class}
                     bordered={false}
                     placeholder="" 
                     onChange={(e)=>handleSelect(e,'class')} 
                     options={filter_standard} 
                     className='w-full border outline-0 focus:outline-0 focus:ring-0 focus:border-none  focus:border-transparent focus:ring-offset-0 focus:shadow-none'
          
                     />
                   {error.class !== '' && error.class !== undefined &&
                   <div className='flex items-center mt-1'>
                   <BiErrorCircle className='text-red-500' size={14} />
                   <span className='text-[10px] text-red-500 ml-1'>{error.class}</span>
                   </div>}


        </div>

       
    

         <div className='flex mt-4 pb-5'>
            <ButtonOutlinedAutoWidth btnName={'Back'} onClick={()=>{navigate(-1)}} />
            <div className='ml-2'>
            <ButtonFilledAutoWidth btnName={'Save'} onClick={submitdata} />
            </div>
         </div>
        </div>
       
         </div>
         </div>
         </div>




    </div>
  )
}

export default ClassHomePageDataCE